import { api, ui, utils } from "services";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Popup } from "semantic-ui-react";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { AuthEntity, AuthInterface, LoginType, Size } from 'interfaces';
import { RootState } from 'reducer/store';
import { useTranslation } from 'react-i18next';
import { setLoginType } from "reducer/logintype.slice";
import { removeAuthInfo, setAuthInfos } from "reducer/wallet.slice";
import { SSO_META } from "config";
import ReactFacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { signInWithApple, signInWithGoogle } from "services/firebase";

export const SocialCard = ({
    data,
    size,
    className,
    type
}: {
    data: AuthEntity,
    size: Size,
    className?: string,
    type: LoginType
}) => {
    const [isCopied, setIsCopied] = useState(false);
    const dispatch = useDispatch();
    const wallets = useSelector((state: RootState) => state.wallets);
    const { t } = useTranslation();


    const connectExtension = async (accessToken: string) => {
        try {
            await api.linkSocial({ accessToken, type: type });
            const authInfos = await api.getAuthInfos();
            dispatch(setAuthInfos(authInfos));
        } catch (err: any) {
            ui.alertFailed("", t(err.message))
        }
    }
    const disconnectExtension = async () => {
        try {
            let availableAuths = utils.getAvailableAuths(wallets, type);
            await api.unlinkWallet(data[AuthInterface.identity], type)
            ui.alertSuccess(`Disconnect ${LoginType[type]} successful !`, "");
            dispatch(removeAuthInfo({ type }))
            dispatch(setLoginType(availableAuths[0]))
        } catch (err: any) {
            ui.alertFailed(`Disconnect ${LoginType[type]} failed !`, t(err.message));
        }
    }

    switch (size) {
        case Size.Big:
            return (
                <div className={`${className} w-full rounded-lg`}
                    style={{
                        background: `url("/assets/images/wallets/${LoginType[type].toLowerCase()}-wallet.png")`,
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                        backgroundSize: "cover",
                        minHeight: "180px",
                        backgroundPosition: "bottom right"
                    }}
                >
                    <div className="h-36 md:h-28 p-4 px-6">
                        <div className="flex justify-between">
                            <div>{LoginType[type].toString()}</div>
                            <div className="flex float-right">
                                <Popup position="bottom center"
                                    content={isCopied ? "Copied" : data[AuthInterface.identity]}
                                    onClose={() => setIsCopied(false)}
                                    disabled={!data[AuthInterface.identity]}
                                    trigger={
                                        <CopyToClipboard
                                            text={data[AuthInterface.identity]}
                                            onCopy={() => {
                                                setIsCopied(true)
                                            }}
                                        >
                                            <img
                                                src="/assets/images/icons/copy-icon.svg" alt="copy"
                                                className="h-6 w-6 cursor-pointer" />
                                        </CopyToClipboard>
                                    } />
                                <Popup
                                    position="bottom center" content={data[AuthInterface.identity] ?
                                        `Unlink ${LoginType[type]}` : `Attach ${LoginType[type]}`}
                                    disabled={!data[AuthInterface.identity]}
                                    trigger={
                                        data[AuthInterface.identity] ? <img
                                            src={`/assets/images/icons/link-wallet-icon.svg`}
                                            alt="wallet-icon"
                                            className="h-6 w-6 ml-2 cursor-pointer"
                                            onClick={disconnectExtension}
                                        /> :
                                            <>
                                                {type === LoginType.Google &&
                                                    <img
                                                        src={`/assets/images/icons/unlink-wallet-icon.svg`}
                                                        alt="wallet-icon"
                                                        className="h-6 w-6 ml-2 cursor-pointer"
                                                        onClick={async () => {
                                                            let res = await signInWithGoogle();
                                                            let credential = res._tokenResponse;
                                                            let accessToken = credential.oauthAccessToken;
                                                            await connectExtension(accessToken);
                                                        }}
                                                    />
                                                }
                                                {type === LoginType.Apple &&
                                                    <img
                                                        src={`/assets/images/icons/unlink-wallet-icon.svg`}
                                                        alt="wallet-icon"
                                                        className="h-6 w-6 ml-2 cursor-pointer"
                                                        onClick={async () => {
                                                            let res = await signInWithApple();
                                                            let idToken = res.idToken;
                                                            await connectExtension(idToken);
                                                        }}
                                                    />
                                                }

                                                {type === LoginType.Facebook && <ReactFacebookLogin
                                                    cookie={true}
                                                    appId={SSO_META().FACEBOOK_APP_ID}
                                                    autoLoad={false}
                                                    fields="name,email,picture"
                                                    render={renderProps => (
                                                        <img
                                                            src={`/assets/images/icons/unlink-wallet-icon.svg`}
                                                            alt="wallet-icon"
                                                            className="h-6 w-6 ml-2 cursor-pointer"
                                                            onClick={renderProps.onClick}
                                                        />
                                                    )}
                                                    callback={async (res: any) => {
                                                        let accessToken = res.accessToken;
                                                        await connectExtension(accessToken);
                                                    }}
                                                    onFailure={console.log}
                                                />}
                                            </>
                                    }>
                                </Popup>
                            </div>
                        </div>
                        <p className="font-normal mt-2 text-white-light text-lg">
                            {LoginType[type].toString()} id: {" "}
                            {utils.displayWalletAddress(data[AuthInterface.identity])}
                        </p>
                        <div className="block my-2 bottom-10 absolute">
                            <span className="font-medium text-2xl">
                            </span>
                        </div>
                    </div>
                </div >
            )

        case Size.Small:
            return (
                <></>
            )
    }
}
